import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import i18n from "i18next";


const AppTopbar = ({ onToggleMenu }) => {
  const jsonBreadCrumP = [
    { pathname: '/dashboard' , bread: `${i18n.t('Inicio')}` },
    { pathname: '/users/internal' , bread: `${i18n.t('Inicio')} / ${i18n.t('Usuarios internos')}` },
    { pathname: '/users/internal/bulk-load' , bread: `${i18n.t('Inicio')} / ${i18n.t('Usuarios internos')} / ${i18n.t('Carga masiva')}` },
    { pathname: '/users/internal/import' , bread: `${i18n.t('Inicio')} / ${i18n.t('Usuarios internos')} / ${i18n.t('Carga masiva')} / ${i18n.t('Configurar carga')}` },
    { pathname: '/sections' , bread: `${i18n.t('Inicio')} / ${i18n.t('Secciones')}` },
    { pathname: '/section/new' , bread: `${i18n.t('Inicio')} / ${i18n.t('Secciones')} / ${i18n.t('Agregar')}` },
    { pathname: '/section/edit' , bread: `${i18n.t('Inicio')} / ${i18n.t('Secciones')} / ${i18n.t('Editar')}` },
    { pathname: '/documents' , bread: `${i18n.t('Inicio')} / ${i18n.t('Documentos')}` },
    { pathname: '/document/new' , bread: `${i18n.t('Inicio')} / ${i18n.t('Documentos')} / ${i18n.t('Agregar')}` },
    { pathname: '/document/edit' , bread: `${i18n.t('Inicio')} / ${i18n.t('Documentos')} / ${i18n.t('Editar')}` },
    { pathname: '/document/report' , bread: `${i18n.t('Inicio')} / ${i18n.t('Documentos')} / ${i18n.t('Reporte de Lectores')}` },
    { pathname: '/business' , bread: `${i18n.t('Inicio')} / ${i18n.t('Empresas')}` },
    { pathname: '/company/new' , bread: `${i18n.t('Inicio')} / ${i18n.t('Empresas')} / ${i18n.t('Agregar')}` },
    { pathname: '/company/edit' , bread: `${i18n.t('Inicio')} / ${i18n.t('Empresas')} / ${i18n.t('Editar')}` },
    { pathname: '/countries' , bread: `${i18n.t('Inicio')} / ${i18n.t('Paises')}` },
    { pathname: '/languages' , bread: `${i18n.t('Inicio')} / ${i18n.t('Idiomas')}` },
    { pathname: '/languages/dictionary' , bread: `${i18n.t('Inicio')} / ${i18n.t('Idiomas')} / ${i18n.t('Diccionario')}` },
  
  
    { pathname: '/admins' , bread: `${i18n.t('Inicio')} / ${i18n.t('Administradores')}` },
    { pathname: '/admin/new' , bread: `${i18n.t('Inicio')} / ${i18n.t('Administradores')} / ${i18n.t('Agregar')}` },
    { pathname: '/admin/edit' , bread: `${i18n.t('Inicio')} / ${i18n.t('Administradores')} / ${i18n.t('Editar')}` },

    { pathname: '/supplier/search' , bread: `${i18n.t('Inicio')} / ${i18n.t('Proveedores')}` },
    { pathname: '/supplier/detail' , bread: `${i18n.t('Inicio')} / ${i18n.t('Proveedores')} / ${i18n.t('Detalle')}` },
    
    { pathname: '/profiles' , bread: `${i18n.t('Inicio')} / ${i18n.t('Perfiles')}` },
    { pathname: '/profile/new' , bread: `${i18n.t('Inicio')} / ${i18n.t('Perfiles')} / ${i18n.t('Agregar')}` },
    { pathname: '/profile/edit' , bread: `${i18n.t('Inicio')} / ${i18n.t('Perfiles')} / ${i18n.t('Editar')}` },
    
    { pathname: '/reports' , bread: `${i18n.t('Inicio')} / ${i18n.t('Reportes')}` },
    { pathname: '/emails' , bread: `${i18n.t('Inicio')} / ${i18n.t('Emails')}` },
    { pathname: '/email/new' , bread: `${i18n.t('Inicio')} / ${i18n.t('Emails')} / ${i18n.t('Agregar')}` },
    { pathname: '/email/edit' , bread: `${i18n.t('Inicio')} / ${i18n.t('Emails')} / ${i18n.t('Editar')}` },

    { pathname: '/blacklist-domains' , bread: `${i18n.t('Inicio')} / ${i18n.t('Lista negra de dominios')}` },

    { pathname: '/evaluators' , bread: `${i18n.t('Inicio')} / ${i18n.t('Procesos')} / ${i18n.t('Evaluadores')}` },
    { pathname: '/roles' , bread: `${i18n.t('Inicio')} / ${i18n.t('Procesos')} / ${i18n.t('Roles en procesos')}` },
    { pathname: '/process-dictionary' , bread: `${i18n.t('Inicio')} / ${i18n.t('Procesos')} / ${i18n.t('Diccionario')}` },
    { pathname: '/anexos' , bread: `${i18n.t('Inicio')} / ${i18n.t('Procesos')} / ${i18n.t('Anexos')}` },
    { pathname: '/validate-digital-stamp' , bread: `${i18n.t('Inicio')} / ${i18n.t('Procesos')} / ${i18n.t('Validar sello digital')}` },
    
    { pathname: '/bitacora' , bread: `${i18n.t('Inicio')} / ${i18n.t('Bitacora de cambios')}` },

    { pathname: '/type-users' , bread: `${i18n.t('Inicio')} / ${i18n.t('Tipos de usuarios')}` },
    { pathname: '/type-users/allowed-sections' , bread: `${i18n.t('Inicio')} / ${i18n.t('Tipos de usuarios')} /  ${i18n.t('Secciones permitidas')}` }
  ]

  const [breadCrum, setBreadCrum] = useState('')
  const [jsonBreadCrum, setJsonBreadCrum] = useState(jsonBreadCrumP)
  const history = useHistory();
  

  
  const getBreadCrum = (history) => {
    const breadCrum = jsonBreadCrum.find(item => item.pathname === history.pathname)
    setBreadCrum(breadCrum?.bread || '')
  }

  useEffect(() => {
    getBreadCrum(history.location)
    return history.listen(getBreadCrum)
  }, []);

  useEffect(async () => {
    setJsonBreadCrum(jsonBreadCrumP)
  }, [i18n.language] );

  useEffect(async () => {
    getBreadCrum(history.location)
    return history.listen(getBreadCrum)
  }, jsonBreadCrum);

  return (
    <div className="layout-topbar clearfix">
      <button
        type="button"
        className="p-link layout-menu-button"
        onClick={onToggleMenu}
      >
        <span className="pi pi-bars" />
      </button>
      <span className="layout-topbar-item-text p-pl-6" style={{'fontSize': '1.1rem', 'fontWeight': '500'}}>{breadCrum || ''}</span>
      <div className="layout-topbar-icons">
        {/* <button type="button" className="p-link">
          <span className="layout-topbar-item-text">User</span>
          <span className="layout-topbar-icon pi pi-user" />
        </button> */}
      </div>
    </div>
  );
}

export default AppTopbar;
